"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BBAuthInterop = void 0;
var auth_1 = require("../auth");
var navigator_1 = require("./navigator");
var HOST_ORIGIN = 'https://host.nxt.blackbaud.com';
function messageIsFromSource(event, source) {
    if (event.origin === HOST_ORIGIN) {
        var message = event.data;
        return !!message && message.source === source;
    }
    return false;
}
var BBAuthInterop = /** @class */ (function () {
    function BBAuthInterop() {
    }
    /* istanbul ignore next */
    BBAuthInterop.postOmnibarMessage = function (iframeEl, message, origin) {
        message.source = 'auth-client';
        iframeEl.contentWindow.postMessage(message, origin || HOST_ORIGIN);
    };
    BBAuthInterop.messageIsFromOmnibar = function (event) {
        return messageIsFromSource(event, 'skyux-spa-omnibar');
    };
    BBAuthInterop.messageIsFromOmnibarVertical = function (event) {
        return messageIsFromSource(event, 'skyux-spa-omnibar-vertical');
    };
    BBAuthInterop.messageIsFromToastContainer = function (event) {
        return messageIsFromSource(event, 'skyux-spa-omnibar-toast-container');
    };
    BBAuthInterop.handleGetToken = function (iframeEl, tokenRequestId, disableRedirect, completeCb) {
        var _this = this;
        return auth_1.BBAuth.getToken({
            disableRedirect: disableRedirect,
        }).then(function (token) {
            if (completeCb) {
                completeCb();
            }
            _this.postOmnibarMessage(iframeEl, {
                messageType: 'token',
                token: token,
                tokenRequestId: tokenRequestId,
            });
        }, function (reason) {
            if (completeCb) {
                completeCb();
            }
            _this.postOmnibarMessage(iframeEl, {
                messageType: 'token-fail',
                reason: reason,
                tokenRequestId: tokenRequestId,
            });
        });
    };
    BBAuthInterop.postLocationChangeMessage = function (iframeEl, url, category) {
        if (iframeEl) {
            BBAuthInterop.postOmnibarMessage(iframeEl, {
                href: url,
                category: category,
                messageType: 'location-change',
            });
        }
    };
    BBAuthInterop.handleNavigate = function (nav, navItem) {
        if (!nav ||
            !nav.beforeNavCallback ||
            nav.beforeNavCallback(navItem) !== false) {
            navigator_1.BBAuthNavigator.navigate(navItem.url);
        }
    };
    BBAuthInterop.getCurrentUrl = function () {
        return document.location.href;
    };
    BBAuthInterop.getCurrentPath = function () {
        return document.location.pathname;
    };
    return BBAuthInterop;
}());
exports.BBAuthInterop = BBAuthInterop;
